import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UtilisateursRoutingModule } from './utilisateurs-routing.module';
import { ApprenantsComponent } from './components/apprenants/apprenants.component';
import { ProfilsComponent } from './components/profils/profils.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProfilComponent } from './components/profil/profil.component';
import { MatFormFieldModule } from '@angular/material/form-field'; //add
import { MatTableModule } from '@angular/material/table'; // Ajout de MatTableModule
import { MatInputModule } from '@angular/material/input'; // Ajout de MatInputModule,
import { MatPaginatorModule } from '@angular/material/paginator'; // Ajoutez cette ligne
import { MatCheckboxModule } from '@angular/material/checkbox'; // Ajout de cette ligne
import { MatIconModule } from '@angular/material/icon'; // Ajout de cette ligne
import { CreateUserComponent } from './components/create-user/create-user.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { StatisticsGlobalComponent } from './components/statistics-global/statistics-global.component';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { ConfirmationComponent } from '../../components/confirmation/confirmation.component';
import { ApprenantbeninComponent } from './components/apprenantbenin/apprenantbenin.component';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
  declarations: [
    ApprenantsComponent,
    ProfilsComponent,
    ProfilComponent,
    CreateUserComponent,
    StatisticsComponent,
    StatisticsGlobalComponent,
    PortfolioComponent,
    ConfirmationComponent,
    ApprenantbeninComponent,
  ],
  imports: [
    CommonModule,
    UtilisateursRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatFormFieldModule,
    MatTableModule,
    MatInputModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatIconModule,
     DropdownModule
  ],
})
export class UtilisateursModule {}
